module.exports = __webpack_public_path__ + "static/media/jungle-crossroad.c31b4a28.png";